import React, { useState } from "react";
import DataTable from '../../components/DataTable'
import { activitiesTableConfig } from "../../datatable.config";
import { Box, Chip, CircularProgress, Grid, Hidden, LinearProgress, Paper, Stack, TablePagination, Typography, useTheme } from "@mui/material";
import CardComponent from "../../components/Card";
import { useTranslation } from "react-i18next";
import { formatDateToDDMMYYYYHHSSFrEpoch, mappingValue } from "../../utils/util";
import LinearBuffer from "./LinearBuffer"

export default function RemoveDeviceView(props) {

    const { listRemoveDevice, paging } = props
    const [rowsPerPage, setRowsPerPage] = useState(paging && paging.size ? paging.size : 10);
    const { t } = useTranslation();

    const handleChangePage = (event, newPage) => {
        props.handleChangePage(newPage + 1);
    };

    const handleChangeRowsPerPage = (event) => {
        let value = event.target.value;
        let _size = paging.size ? paging.size : 10;
        console.log("AAA parseInt(value, _size): ", parseInt(value, _size))
        setRowsPerPage(value);
        props.handleChangeRowsPerPage(value);
    };

    return (
        <CardComponent noBorder marginTop={5}
            header={{
                title: t('remove_device_activity'),
            }}>
            {props.showExecutionProcess && <Grid container justifyContent="flex-end">
                <Grid item component={Paper}>
                    <LinearBuffer status={props.actionState} />
                </Grid>
            </Grid>}
            {props.showLoadingRemoveDevice ? <Stack flex={1} alignItems={'center'}><CircularProgress /></Stack> :
                <>
                    <Hidden mdDown>
                        <DataTable
                            data={listRemoveDevice} tableConfig={activitiesTableConfig} onShowDetail={props.onShowSerialInput}
                        ></DataTable>
                    </Hidden>
                    <Hidden mdUp>
                        {listRemoveDevice.length == 0 ? <Typography variant='subtitle2'>No Record Found.</Typography> :
                            listRemoveDevice.map((item, index) => {
                                return (
                                    <Box key={index} mb={1} onClick={() => props.onShowSerialInput(item)}>
                                        <ActivityItem item={item} />
                                    </Box>
                                )
                            })}
                    </Hidden>
                    {paging.total > 0 && <TablePagination
                        component="div"
                        count={paging.total}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        page={paging.page ? paging.page - 1 : 0}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />}
                </>}
        </CardComponent>
    )
}

function ActivityItem(props) {
    const { item } = props;
    const { palette } = useTheme();
    const { t } = useTranslation();

    let statusColor = palette.info;
    if (item.state == 'COMPLETED') statusColor = palette.success;
    else if (item.state == 'PENDING') statusColor = palette.warning;

    return (
        <CardComponent paddingY={1} paddingX={2}>
            <Stack direction={'row'} alignItems={'center'} spacing={1}>
                <Stack flex={1} direction={'row'} alignItems='center' spacing={1}>
                    <Typography variant='body1'>{item.name}</Typography>
                    <Chip sx={{ background: statusColor.light, color: statusColor.main }} variant='customOutlined' size='small' label={t(mappingValue(item.state))} />
                </Stack>
            </Stack>
            <Stack direction={'row'} alignItems='center' spacing={1} mt={1}>
                <Stack flex={1}>
                    <Typography variant='body2'>{item.contact && item.contact.name ? item.contact.name : null}</Typography>
                </Stack>
                <Stack flex={1} direction='row' justifyContent={'flex-end'}>
                    <Typography variant='subtitle2'>{formatDateToDDMMYYYYHHSSFrEpoch(item.created_date)}</Typography>
                </Stack>
            </Stack>
        </CardComponent>
    )
}
